import MenuItem from "@mui/material/MenuItem";
import { useSidebarState } from "react-admin";

export const MenuHeading = ({ label }) => {
  const [open] = useSidebarState();

  return (
    <MenuItem style={{ paddingTop: 25 }} disabled={true}>
      {open ? label : null}
    </MenuItem>
  );
};
